import {
    Drawer,
    Input,
    Col,
    Form,
    Button,
    Row,
    Spin,
    Select
} from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
import { useEffect, useLayoutEffect, useState } from 'react';
import { errorNotification, successNotification } from '@/utils/Notification';
import { useDebounce } from '@/utils/DebounceHook';
import SearchBar from '@/pages/assets/SearchBar';
import { Assets } from './AssetColumns';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '@/context/UseAxiosPrivate';
import axios from 'axios';
import Spinner from '../spinnner/Spinner';
import SpinnerForm from '../spinnner/SpinnerForm';

const { Option } = Select;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
interface AssetDrawerProps {
    updateAssetShowDrawer: boolean
    setUpdateAssetShowDrawer: React.Dispatch<React.SetStateAction<boolean>>
    Assets: Assets
    getAssets: any
    setAssetData: React.Dispatch<React.SetStateAction<Assets | undefined>>
}
const AssetUpdateDrawer: React.FC<AssetDrawerProps> = ({ updateAssetShowDrawer, setUpdateAssetShowDrawer, Assets, getAssets, setAssetData }) => {
    const [submitting, setSubmitting] = useState(false);
    const [searchTermForCustomer, setSearchTermForCustomer] = useState('')
    const [customerToDisplay, setCustomerToDisplay] = useState([])
    const [customerOptions, setCustomerOptions] = useState([])
    const [searchTermForProducts, setSearchTermForProducts] = useState('')
    const [productsToDisplay, setProductsToDisplay] = useState([])
    const [productsOptions, setProductsOptions] = useState([])
    const [searchTermForTechnicians, setSearchTermForTechnicians] = useState('')
    const [techniciansToDisplay, setTechniciansToDisplay] = useState([])
    const [techniciansOptions, setTechniciansOptions] = useState([])
    const [searchTermForBeacons, setSearchTermForBeacons] = useState('')
    const [beaconsToDisplay, setBeaconsToDisplay] = useState<any[]>([]);
    const [beaconsOptions, setBeaconsOptions] = useState([])
    const [loadingForm, setLoadingForm] = useState(true);
    const [form] = Form.useForm()
    const navigate = useNavigate();
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate();
    const onCLose = () => {
        setAssetData(undefined)
        setUpdateAssetShowDrawer(false)
    };


    useEffect(() => {
        const setFormValues = async () => {
            const customer: any = customerToDisplay.find((c: any) => c.id === Assets.customer_id) ||
                await getSpecifiCustomerByCustomerId(Assets.customer_id)
            const product = productsToDisplay.find((p: any) => p.id === Assets.product_id) ||
                await getSpecifiProductsById(Assets.product_id);
            const technician: any = techniciansToDisplay.find((t: any) => t.id === Assets.technician_id) ||
                await getSpecifiTechniciansById(Assets.technician_id)
            const beacon: any = beaconsToDisplay.find((b: any) => b.id === Assets.beacon_id) ||
                await getSpecifiBeaconsById(Assets.beacon_id);

            form.setFieldsValue({
                customer_id: customer ? { value: customer.id, label: customer.name } : undefined,
                product_id: product ? { value: product.id, label: product.name } : undefined,
                technician_id: technician ? { value: technician.id, label: `${technician.first_name} ${technician.last_name}` } : undefined,
                beacon_id: beacon ? { value: beacon.id, label: beacon.cid } : undefined,
                registration: Assets.registration,
                client_name: Assets.client_name,
                loan_id: Assets.loan_id,
                status: Assets.status,
                id: Assets.id
            })
            setLoadingForm(false);
        };
        if (Assets) {
            setFormValues()
        }
    }, [Assets, customerToDisplay, productsToDisplay, techniciansToDisplay, beaconsToDisplay, form])

    const getCustomers = () => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/customers', {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: any) => {
                if (isMounted) {
                    setCustomerToDisplay(data);
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            })
        return () => {
            isMounted = false
            controller.abort()
        }
    }

    useEffect(() => {
        getCustomers()
    }, [])

    const getProducts = () => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/products', {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: any) => {
                if (isMounted) {
                    setProductsToDisplay(data)
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    useEffect(() => {
        getProducts()
    }, [])

    const getTechnicians = () => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/technicians', {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: any) => {
                if (isMounted) {
                    setTechniciansToDisplay(data)
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    useEffect(() => {
        getTechnicians()
    }, [])

    const getTechniciansBeacons = (technician_store_id: any) => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get(`/api/v1/beacons/technicianBeacons?beaconStoreId=${technician_store_id}`, {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: any) => {
                if (isMounted) {
                    setBeaconsToDisplay(data)
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    useEffect(() => {
        getTechniciansBeacons(Assets.technician_store_id)
    }, [Assets.technician_store_id])



    const getClientIPAndURL = async () => {
        try {
            // Fetch the client IP address (example using ipify)
            const response = await axios.get('https://api.ipify.org?format=json');
            const clientIp = response.data.ip;

            // Get the current URL
            const currentUrl = window.location.href;

            return { clientIp, currentUrl };
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return { clientIp: 'Unknown', currentUrl: window.location.href };
        }
    };

    const onFinish = (assets: any) => {
        setSubmitting(true)
        let isMounted = true;
        const controller = new AbortController()
        const extractedAssets = {
            ...assets,
            customer_id: assets.customer_id?.value ? assets.customer_id.value : assets.customer_id,
            product_id: assets.product_id?.value ? assets.product_id.value : assets.product_id,
            technician_id: assets.technician_id?.value ? assets.technician_id.value : assets.technician_id,
            beacon_id: assets.beacon_id?.value ? assets.beacon_id.value : assets.beacon_id,
        }
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivate.put(`/api/v1/assets/${extractedAssets.id}`, extractedAssets, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then(() => {
            if (isMounted) {
                onCLose()
                successNotification(
                    "Beacon Store successfully added",
                    `${assets.name} was added to the system`,
                    'topRight'
                )
            }
            getAssets()
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        }).finally(() => {
            setSubmitting(false)
        })
        return () => {
            isMounted = false;
            controller.abort();
        }
    };

    const onFinishFailed = (errorInfo: any) => {
        alert(JSON.stringify(errorInfo, null, 2));
    }


    const handleCustomerChange = (value: any) => {
        setSearchTermForCustomer(value)
    }
    const handleProductsChange = (value: any) => {
        setSearchTermForProducts(value)
    }
    const handleTechniciansChange = (value: any) => {
        setSearchTermForTechnicians(value)
    }
    const handleBeaconsChange = (value: any) => {
        setSearchTermForBeacons(value)
    }


    const searchCustomerBySearchTerm = () => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get(`/api/v1/customers/search?query=${searchTermForCustomer}`, {
            signal: controller.signal
        }).then((response) => {
            if (isMounted) {
                setCustomerToDisplay(response.data.data)
            }
        })
            .catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            })
        return () => {
            isMounted = false;
            controller.abort();
        };
    }
    useDebounce(searchTermForCustomer, 50, searchCustomerBySearchTerm)

    const searchProductsBySearchTerm = () => {
        let isMounted = true;
        const controller = new AbortController();
        axiosPrivate.get(`/api/v1/products/search?query=${searchTermForProducts}`, {
            signal: controller.signal
        }).then((response) => {
            if (isMounted) {
                setProductsToDisplay(response.data.data)
            }
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    }
    useDebounce(searchTermForProducts, 50, searchProductsBySearchTerm)

    const searchTechniciansBySearchTerm = () => {
        let isMounted = true;
        const controller = new AbortController();
        axiosPrivate.get(`/api/v1/technicians/search?query=${searchTermForTechnicians}`, {
            signal: controller.signal
        }).then((response) => {
            if (isMounted) {
                setTechniciansToDisplay(response.data.data);
            }
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    }
    useDebounce(searchTermForTechnicians, 50, searchTechniciansBySearchTerm)


    const getSpecifiCustomerByCustomerId = async (customerId: any) => {
        let isMountedR = true;
        const controllerRole = new AbortController()

        const fetchDatadata = async (customerId: any) => {
            isMountedR = true;
            try {
                let res: any = await axiosPrivate.get(`/api/v1/customers/${customerId}`, {
                    signal: controllerRole.signal
                })
                const data = res.data.data
                return data && data.length > 0 ? data[0] : {}

            } catch (err: any) {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
                return {}
            }
        }
        const cleanup = () => {
            isMountedR = false;
            controllerRole.abort();
        };
        const result2 = await fetchDatadata(customerId)
        cleanup()
        return result2;
    }


    const getSpecifiProductsById = async (productId: any) => {

        let isMountedR = true;
        const controllerRole = new AbortController()

        const fetchDatadata = async (productId: any) => {
            isMountedR = true;
            try {
                let res: any = await axiosPrivate.get(`/api/v1/products/${productId}`, {
                    signal: controllerRole.signal
                })
                const data = res.data.data
                return data && data.length > 0 ? data[0] : {}

            } catch (err: any) {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
                return {}
            }
        }
        const cleanup = () => {
            isMountedR = false;
            controllerRole.abort();
        };
        const result2 = await fetchDatadata(productId)
        cleanup()
        return result2;
    };

    const getSpecifiTechniciansById = async (technicianId: any) => {
        let isMountedR = true;
        const controllerRole = new AbortController()

        const fetchDatadata = async (technicianId: any) => {
            isMountedR = true;
            try {
                let res: any = await axiosPrivate.get(`/api/v1/technicians/${technicianId}`, {
                    signal: controllerRole.signal
                })
                const data = res.data.data
                return data && data.length > 0 ? data[0] : {}

            } catch (err: any) {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
                return {}
            }
        }
        const cleanup = () => {
            isMountedR = false;
            controllerRole.abort();
        };
        const result2 = await fetchDatadata(technicianId)
        cleanup()
        return result2;
    }

    const getSpecifiBeaconsById = async (beaconId: any) => {
        let isMountedR = true;
        const controllerRole = new AbortController()

        const fetchDatadata = async (beaconId: any) => {
            isMountedR = true;
            try {
                let res: any = await axiosPrivate.get(`/api/v1/beacons/${beaconId}`, {
                    signal: controllerRole.signal
                })
                const data = res.data.data
                return data && data.length > 0 ? data[0] : {}

            } catch (err: any) {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
                return {}
            }
        }
        const cleanup = () => {
            isMountedR = false;
            controllerRole.abort();
        };
        const result2 = await fetchDatadata(beaconId)
        cleanup()
        return result2;
    }






    useEffect(() => {
        const updatedCustomerOptions: any = customerToDisplay.map((customer: any) => ({
            label: customer.name,
            value: customer.id
        }));
        setCustomerOptions(updatedCustomerOptions);
    }, [customerToDisplay])

    useLayoutEffect(() => {
        const updatedProductsOptions: any = productsToDisplay.map((product: any) => ({
            label: product.name,
            value: product.id
        }));
        setProductsOptions(updatedProductsOptions);
    }, [productsToDisplay])

    useLayoutEffect(() => {
        const updatedTechniciansOptions: any = techniciansToDisplay.map((technicians: any) => ({
            label: `${technicians.first_name} ${technicians.last_name}`,
            value: technicians.id
        }));
        setTechniciansOptions(updatedTechniciansOptions);
    }, [techniciansToDisplay])

    useLayoutEffect(() => {
        const updatedBeaconsOptions: any = beaconsToDisplay.map((beacons: any) => ({
            label: beacons.cid,
            value: beacons.id
        }));
        setBeaconsOptions(updatedBeaconsOptions)
    }, [beaconsToDisplay])



    const filterCustomerOptions = (inputValue: any, option: any) => {
        const label = option.props.children;
        if (label && typeof label === 'string') {
            return label.toLowerCase().includes(inputValue.toLowerCase());
        }
        return false;
    }



    const filterProductsOptions = (inputValue: any, option: any) => {
        const label = option.props.children;
        if (label && typeof label === 'string') {
            return label.toLowerCase().includes(inputValue.toLowerCase());
        }
        return false;
    }

    const filterTechniciansOptions = (inputValue: any, option: any) => {
        const label = option.props.children;
        if (label && typeof label === 'string') {
            return label.toLowerCase().includes(inputValue.toLowerCase());
        }
        return false;
    }
    const filterBeaconsOptions = (inputValue: any, option: any) => {
        const label = option.props.children;
        if (label && typeof label === 'string') {
            return label.toLowerCase().includes(inputValue.toLowerCase());
        }
        return false;
    }



    const handleLivestockSelect = (value: any) => {
        console.log("Selected livestock ID:", value);
    }



    return <Drawer
        title="update Asset"
        width={720}
        onClose={onCLose}
        open={updateAssetShowDrawer}
        bodyStyle={{ paddingBottom: 80 }}
        style={{ backgroundColor: 'white' }}
        footer={
            <div
                style={{
                    textAlign: 'right',
                }}
            >
                <Button onClick={onCLose} style={{ marginRight: 8 }}>
                    Cancel
                </Button>
            </div>
        }
    >


        {(loadingForm) ? (
            <div>
                <SpinnerForm />
            </div>
        )
            : (
                <Form layout="vertical"
                    onFinishFailed={onFinishFailed}
                    onFinish={onFinish}
                    initialValues={{
                        customer_id: Assets.customer_name,
                        product_id: Assets.product_name,
                        technician_id: Assets.technician_name,
                        beacon_id: Assets.cid,
                        registration: Assets.registration,
                        client_name: Assets.client_name,
                        loan_id: Assets.loan_id,
                        status: Assets.status,
                        id: Assets.id
                    }}
                    // initialValues={Assets}
                    form={form}
                    hideRequiredMark>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="customer_id"
                                label="customer name"
                                rules={[{ required: true, message: 'Please slect customer name' }]}
                            >
                                <Select
                                    placeholder="Please select customer name"
                                    showSearch
                                    style={{ borderColor: 'black' }}
                                    onSearch={handleCustomerChange}
                                    filterOption={filterCustomerOptions}
                                    onSelect={handleLivestockSelect}
                                >
                                    {customerOptions.map((option: any) => (
                                        <Option key={option.value} value={option.value}>{option.label}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="product_id"
                                label="Product name"
                                rules={[{ required: true, message: 'Please slect product name' }]}
                            >
                                <Select
                                    placeholder="Please select product name"
                                    showSearch
                                    style={{ borderColor: 'black' }}
                                    onSearch={handleProductsChange}
                                    filterOption={filterProductsOptions}
                                    onSelect={handleLivestockSelect}
                                >
                                    {productsOptions.map((option: any) => (
                                        <Option key={option.value} value={option.value}>{option.label}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="technician_id"
                                label="technician name"
                                rules={[{ required: true, message: 'Please select technician name' }]}
                            >
                                <Select
                                    placeholder="Please select technician name"
                                    showSearch
                                    onSearch={handleTechniciansChange}
                                    filterOption={filterTechniciansOptions}
                                    onSelect={handleLivestockSelect}
                                >
                                    {techniciansOptions.map((option: any) => (
                                        <Option key={option.value} value={option.value}>{option.label}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="beacon_id"
                                label="CID"
                                rules={[{ required: true, message: 'Please select cid' }]}
                            >
                                <Select
                                    placeholder="Please select cid"
                                    showSearch
                                    className="text-black"
                                    onSearch={handleBeaconsChange}
                                    filterOption={filterBeaconsOptions}
                                    onSelect={handleLivestockSelect}
                                >
                                    {beaconsOptions.map((option: any) => (
                                        <Option key={option.value} value={option.value}>{option.label}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="registration"
                                label="Registration"
                                rules={[{ required: true, message: 'Please enter registartion' }]}
                            >
                                <Input placeholder="Please enter registartion" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="client_name"
                                label="client name"
                                rules={[{ required: true, message: 'Please enter client name' }]}
                            >
                                <Input placeholder="Please enter client name" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="loan_id"
                                label="Loan Id"
                                rules={[{ required: true, message: 'Please enter loan id' }]}
                            >
                                <Input
                                    placeholder="Please enter loan id"
                                    className='focus:border-green-500 hover:border-green-500'

                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="status"
                                label="status"
                                hidden={true}
                                rules={[{ required: true, message: 'Please enter loan id' }]}
                            >
                                <Input placeholder="Please enter loan id" className='focus:border-green-500 hover:border-green-500' />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="id"
                                label="id"
                                hidden={true}
                                rules={[{ required: true, message: 'Please enter loan id' }]}
                            >
                                <Input placeholder="Please enter loan id" className='focus:border-green-500 hover:border-green-500' />
                            </Form.Item>
                        </Col>


                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item>
                                <Button type="primary" htmlType="submit" style={{ backgroundColor: 'green' }}>
                                    Submit
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        {submitting && <Spin indicator={antIcon} />}
                    </Row>
                </Form>
            )}

    </Drawer>
}

export default AssetUpdateDrawer;


